function parseExpensePaymentAmount(value) {
  if (value === undefined || value === null || value === '') return 0;

  var normalized = value.toString().replace(/,/g, '');
  if (typeof convertToHalf === 'function') {
    normalized = convertToHalf(normalized).toString().replace(/,/g, '');
  }

  return parseFloat(normalized) || 0;
}

function formatExpensePaymentCurrency(amount) {
  var value = Math.round(parseExpensePaymentAmount(amount));
  return '¥ ' + value.toLocaleString('en-US');
}

function updateExpensePaymentItemTaxInclusive($row) {
  var excluding = parseExpensePaymentAmount($row.find('.js-expense-payment-item-excluding-tax').val());
  var rate = parseFloat($row.find('.js-expense-payment-item-tax-rate').val()) || 0;
  var inclusive = Math.round(excluding * (1 + rate));
  $row.find('.js-expense-payment-item-tax-inclusive-display').val(formatExpensePaymentCurrency(inclusive));
}

function updateExpensePaymentTotal() {
  var $form = $('#form-create-expense-payment');
  if (!$form.length) return;

  var total = 0;
  $form.find('.expense-payment-item-row:visible').each(function () {
    var $row = $(this);
    if ($row.find('input[name*="_destroy"]').val() === '1') return;

    updateExpensePaymentItemTaxInclusive($row);
    var excluding = parseExpensePaymentAmount($row.find('.js-expense-payment-item-excluding-tax').val());
    var rate = parseFloat($row.find('.js-expense-payment-item-tax-rate').val()) || 0;
    total += Math.round(excluding * (1 + rate));
  });

  var adjustment = parseExpensePaymentAmount($form.find('.js-expense-payment-adjustment').val());
  total += Math.round(adjustment);
  $form.find('.js-expense-payment-total-display').val(formatExpensePaymentCurrency(total));
}

function applyExpensePaymentSelect2Errors($container) {
  $container.find('select.has-error').each(function () {
    $(this).next('.select2-container').find('.select2-selection--single').addClass('has-error');
  });
}

function initExpensePaymentItemSelect2($container) {
  $container.find('.js-expense-payment-item-tax-rate').each(function () {
    var $select = $(this);
    if ($select.hasClass('select2-hidden-accessible')) return;

    $select.select2({
      width: '100%',
      theme: 'bootstrap',
      minimumResultsForSearch: Infinity
    });
  });

  applyExpensePaymentSelect2Errors($container);
}

function initExpensePaymentPage() {
  var $page = $('.expense-payment-page');
  if (!$page.length) return;

  if (typeof setValidateInputDecimal === 'function') {
    setValidateInputDecimal($page[0]);
  }

  $page.find('.select2').select2({
    width: '100%',
    theme: 'bootstrap',
    placeholder: '選択してください',
    allowClear: true,
    language: {
      noResults: function () {
        return '見つかりません。';
      }
    }
  });

  applyExpensePaymentSelect2Errors($page);
  initExpensePaymentItemSelect2($page);
  updateExpensePaymentTotal();

  var $firstError = $page.find('.has-error, .help-block').first();
  if ($firstError.length) {
    $('html, body').animate({ scrollTop: $firstError.offset().top - 120 }, 300);
  }
}

$(document).ready(function () {
  initExpensePaymentPage();
});

$(document).on('input change', '.js-expense-payment-item-excluding-tax, .js-expense-payment-item-tax-rate', function () {
  updateExpensePaymentItemTaxInclusive($(this).closest('.expense-payment-item-row'));
  updateExpensePaymentTotal();
});

$(document).on('change', '#form-create-expense-payment .convert-half-width', function () {
  var $row = $(this).closest('.expense-payment-item-row');
  if ($row.length) {
    updateExpensePaymentItemTaxInclusive($row);
  }
  updateExpensePaymentTotal();
});

$(document).on('input change', '.js-expense-payment-adjustment', function () {
  updateExpensePaymentTotal();
});

$(document).on('cocoon:after-insert', '#form-create-expense-payment', function (e, insertedItem) {
  if (typeof setValidateInputDecimal === 'function') {
    setValidateInputDecimal(insertedItem);
  }
  initExpensePaymentItemSelect2($(insertedItem));
  updateExpensePaymentTotal();
});

$(document).on('cocoon:after-remove', '#form-create-expense-payment', function () {
  updateExpensePaymentTotal();
});

$(document).on('click', '#expense-payment .js-expense-payment-toggle', function (e) {
  e.preventDefault();
  var $group = $(this).closest('.expense-payment-group');
  var $panel = $group.find('.expense-payment-items-panel');
  var expanding = $panel.hasClass('d-none');

  $group.find('.arrow-down, .arrow-up').toggleClass('d-none');
  $panel.toggleClass('d-none', !expanding);
  $group.find('.expense-payment-row').toggleClass('is-expanded', expanding);
});
